import(/* webpackMode: "eager" */ "/builds/natures-way/naturesway-marketing-frontend/app/[locale]/courses/[slug]/error.tsx")